import request from '@/utils/request'

/**
 * 获取近15天的聊天信息, baseURL是wxserver
 * @param data
 * @returns {*}
 */
export function getChatHistory(data) {
  const wxserver_domain = request.defaults.__webConfig.WXSERVER_DOMAIN
  const baseURL = process.env.NODE_ENV === 'development' || request.defaults.__webConfig.MODEL === 'dev' ? '//wxserver.dev.ehafo.com' : '//' + wxserver_domain
  return request.post('/phalapi/public/?service=App.Index.getMessageRecordByHalfMonth', data, { baseURL })
}
